import React from "react";

function Colors_Crayola() {
  return (
    <div>
      <h1>Colors_Crayola Component</h1>
      <p>This is the Colors Crayola tutorial page content.</p>
    </div>
  );
}

export default Colors_Crayola;
